import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { flexCenter } from '@seedlang/style_mixins';
import { AppUI } from '@seedlang/state';
import SeedlangExplainerModal from './seedlang_explainer_modal';

export const SEEDLANG_EXPLAINER_UI_ELEMENT = 'worksheet-vocab-seedlang-explainer';

export const HelpButton = styled.button`
  border: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  cursor: pointer;
  ${flexCenter()}
  background: #A9A9A9;
  color: #FFF;
  font-weight: bold;
  font-size: 12px;
`;

const HelpAnchor = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  position: ${props => props.corner ? 'static' : 'relative'};
`;

const HelpPosition = styled.div`
  position: absolute;
  left: ${props => props.corner ? 'auto' : 'calc(100% + 10px)'};
  right: ${props => props.corner ? '10px' : 'auto'};
  top: ${props => props.corner ? '10px' : '50%'};
  transform: ${props => props.corner ? 'none' : 'translateY(-50%)'};
`;

export const SeedlangExplainer = ({
  children,
  helpInCorner,
  isPodcastEpisode,
  languageName,
  showHelpModal,
  onCloseHelp,
  onOpenHelp,
}) => (
  <>
    <SeedlangExplainerModal
      isPodcastEpisode={isPodcastEpisode}
      languageName={languageName}
      opened={showHelpModal}
      onClose={onCloseHelp}
    />
    <HelpAnchor corner={helpInCorner}>
      {children}
      <HelpPosition corner={helpInCorner}>
        <HelpButton onClick={onOpenHelp} title='Help'>?</HelpButton>
      </HelpPosition>
    </HelpAnchor>
  </>
);

const SeedlangExplainerWrapper = observer(({autoOpenUiElement, isPodcastEpisode, children, helpInCorner}) => {
  const [showHelpModal, setShowHelpModal] = useState(false);
  const userIsLoaded = AppUI.userIsLoaded;

  useEffect(() => {
    if (autoOpenUiElement && userIsLoaded && !AppUI.wasUiElementSeen(autoOpenUiElement)) {
      setShowHelpModal(true);
      AppUI.designateUiElementAsSeen(autoOpenUiElement);
    }
  }, [autoOpenUiElement, userIsLoaded]);

  return (
    <SeedlangExplainer
      helpInCorner={helpInCorner}
      isPodcastEpisode={isPodcastEpisode}
      languageName={AppUI.site.language?.name}
      showHelpModal={showHelpModal}
      onCloseHelp={() => setShowHelpModal(false)}
      onOpenHelp={() => setShowHelpModal(true)}
    >
      {children}
    </SeedlangExplainer>
  );
});

export default SeedlangExplainerWrapper;
